import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import getDisplayName from 'react-display-name';

export type WithProvisioning = {
  provisioningInProgress?: boolean;
};

export const withProvisioning =
  (ProvisioningComponent: React.ComponentType<WithProvisioning>) =>
  <P extends WithProvisioning>(WrappedComponent: React.ComponentType<P>) => {
    class WithProvisioningComponent extends React.Component<P> {
      static displayName = `withProvisioning(${getDisplayName(WrappedComponent)})`;

      render() {
        const { provisioningInProgress } = this.props;
        return provisioningInProgress ? (
          <ProvisioningComponent {...this.props} />
        ) : (
          <WrappedComponent {...this.props} />
        );
      }
    }

    hoistNonReactStatics(WithProvisioningComponent, WrappedComponent);

    return WithProvisioningComponent;
  };
